import api from './api';
import { domainWarmupRoutes, GET, POST, PUT, DELETE } from '../constants/api';

export type RegisterNewDomainDTO = {
  name: string,
  dailyLimit: number,
  ipPool?: string,
  isWarmUp: boolean,
  sgAccount: 'main' | 'alternate',
};

export type UpdateDomainDTO = {
  ipPool?: string,
  isWarmUp?: boolean,
  sgAccount?: 'main' | 'alternate',
};

export type ChangeDailyLimitDTO = {
  domains: string[],
  dailyLimit: number,
};

export type ChangeDistributionDTO = {
  [domain: string]: number,
};

export const getAllDomains = () =>
  api({ method: GET, url: domainWarmupRoutes.GET_ALL_DOMAINS });

export const registerNewDomain = (data: RegisterNewDomainDTO) =>
  api({
    method: POST,
    url: domainWarmupRoutes.REGISTER_NEW_DOMAIN,
    data,
  });

export const updateDomain = (domain: string, data: UpdateDomainDTO) =>
  api({
    method: PUT,
    url: domainWarmupRoutes.UPDATE_DOMAIN(domain),
    data,
  });

export const deleteDomain = (domain: string) =>
  api({
    method: DELETE,
    url: domainWarmupRoutes.DELETE_DOMAIN(domain),
  });

export const changeDailyLimit = (data: ChangeDailyLimitDTO) =>
  api({
    method: POST,
    url: domainWarmupRoutes.CHANGE_DAILY_LIMIT,
    data,
  });

export const changeDistribution = (data: ChangeDistributionDTO) =>
  api({
    method: POST,
    url: domainWarmupRoutes.CHANGE_DISTRIBUTION,
    data,
  });
